export enum NotificationGroup {
  COPY = 'gv-copy',
  FEEDBACK = 'gv-feedback',
}
